import React, { useState } from 'react';
import HourlyPackageModal from './HourlyPackageModal/HourlyPackageModal';
import { HOURLY_LANDING_OPTIONS } from '../../ServicesPages/Shared/hourlyPlanCopy';
import './HourlyShoots2.css';

const HourlyShoots = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const hourOptions = HOURLY_LANDING_OPTIONS;

  return (
    <div className="hourly-shoots-wrapper">
      <section className="Landing-page-hourly-shoots">
        <h2 className="hourly-shoots-main-title">
          <span className="title-text">The Hour Is Yours !</span>
        </h2>

        <div className="hourly-shoots-content-split">
          <div className="hourly-shoots-left">
            <img
              src={`${process.env.PUBLIC_URL}/asset/landing-page/Hourly-Shoot.png`}
              alt="Hourly Section"
              className="hourly-main-img"
            />
            <div className="hourly-image-overlay"></div>
            <div className="hourly-left-text">
              <h3>Hourly Section</h3>
              <p>Designed around your vision, pace & production needs.</p>
            </div>
          </div>

          <div className="hourly-shoots-right">
            {hourOptions.map((option, index) => (
              <div key={index} className="hourly-option-card">
                <h3 className="hourly-card-hours">{option.title}</h3>
                <p className="hourly-card-tagline">{option.tagline}</p>
                <img
                  src={`${process.env.PUBLIC_URL}/asset/landing-page/book-btn.png`}
                  alt="Book Shoot"
                  className="book-btn"
                  onClick={() => setIsModalOpen(true)}
                  style={{ cursor: 'pointer' }}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <HourlyPackageModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </div>
  );
};

export default HourlyShoots;